_getUserDataThunk